<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
    export default {}

</script>
<style>
  #app,html,body {
    overflow-x: hidden;
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
</style>
